import { JsonObject, JsonProperty } from 'json2typescript';

import { DocumentAttachmentGroup, ListBoxItem } from '.';
import { TypeDocument } from './type-document.model';

@JsonObject('selfCareListValues')
export class ListBoxItems {
  @JsonProperty('countries', [ListBoxItem], true)
  public countries: ListBoxItem[] = [];

  @JsonProperty('gender', [ListBoxItem], true)
  public gender: ListBoxItem[] = [];

  @JsonProperty('maritalStatus', [ListBoxItem], true)
  public maritalStatus: ListBoxItem[] = [];

  @JsonProperty('yesNoIdk', [ListBoxItem], true)
  public yesNoIdk: ListBoxItem[] = [];

  @JsonProperty('relationshipWithDeceasedList', [ListBoxItem], true)
  public relationshipWithDeceasedList: ListBoxItem[] = [];

  @JsonProperty('documentAttachmentGroups', [DocumentAttachmentGroup], true)
  public documentAttachmentGroups: DocumentAttachmentGroup[] = [];

  @JsonProperty('selfCareTypeDocuments', [TypeDocument], true)
  public typeDocuments: TypeDocument[] = [];
}
